<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:reportName="reportName"
		:exportUrl="exportUrl"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:sunTable="sunTable"
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
		<IconTip slot="icontip"></IconTip>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/orderItem2.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapBigNew.vue'
import FiltersBox from '@/components/reportform/orderItem/FiltersBox.vue'
import IconTip from '@/components/reportform/orderItem/IconTip.vue'
export default {
	name: 'orderItem2',
	components: {
		reportFormWrap,
		FiltersBox,
		IconTip
	},
	data () {
		return {
			reportid: 'REPORT_ORDER_PRODUCT_000003',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getOrderProductSumReport`,
			exportUrl: `${this.$fxBaseApi.newExportUrl}/orderProductSumReportImport`,
			orderMenu: orderMenu,
			reportName: 'orderItem',
			sunTable: [
				{
					name: '订单数量',
					key: 'orderidcount'
				},
				{
					name: '订单商品数量',
					key: 'livequantity'
				},
				{
					name: '订单商品金额',
					key: 'livemoney'
				}
			]
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
